import React, {useCallback, useEffect} from 'react';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';
import useAutoSave from 'components/customer/RoomPlanner/lib/useAutoSave';
import FloatingMenuButton, {
    FloatingMenuButtonIcon,
} from 'components/customer/RoomPlanner/components/common/FloatingMenuButton';
import {useRoomPlannerContext} from 'components/customer/RoomPlanner/components/RoomPlannerContext';
import {
    isScene,
    syncOverlaysOnCabinetMove,
} from 'components/customer/RoomPlanner/helpers/syncOverlayOnCabinetMove';
import {
    useIsMobileLandscape,
    useIsPortraitDevices,
} from 'shared/helpers/DeviceSize';

const RotateRight = () => {
    const isMobileLandscape = useIsMobileLandscape();
    const isPortraitDevices = useIsPortraitDevices();
    const {selectedCabinetGroup, setRotateRightHandler} =
        useRoomPlannerContext();
    const {debouncedSave} = useAutoSave();

    const handleRotate = useCallback(() => {
        // Safely access userData and call rotateRight
        const userData = selectedCabinetGroup?.userData as {
            rotateRight?: () => void;
        };

        if (
            typeof userData?.rotateRight === 'function' &&
            selectedCabinetGroup
        ) {
            userData.rotateRight();
            debouncedSave(selectedCabinetGroup);
            const scene = selectedCabinetGroup.parent;
            if (isScene(scene)) {
                // Same overlay path as Space / arrow keys so height arrows
                // follow the mesh immediately (not only after the layout effect).
                syncOverlaysOnCabinetMove(selectedCabinetGroup, scene);
            }
        }
    }, [selectedCabinetGroup, debouncedSave]);

    // Register the rotate right handler with the context for keyboard shortcut
    useEffect(() => {
        if (setRotateRightHandler) {
            setRotateRightHandler(handleRotate);
        }
        return () => setRotateRightHandler?.(null);
    }, [handleRotate, setRotateRightHandler]);

    return (
        <OverlayTrigger
            placement="top"
            overlay={<strong>Rotate right (R)</strong>}>
            <FloatingMenuButton onClick={handleRotate}>
                <FloatingMenuButtonIcon
                    className="icon_button"
                    color={
                        isMobileLandscape || isPortraitDevices
                            ? undefined
                            : '#b2bec3'
                    }
                    iconName="Button-Rotate-Clockwise.svg"
                />
                <label>Rotate</label>
            </FloatingMenuButton>
        </OverlayTrigger>
    );
};

export default RotateRight;
